<template>
  <div id="tab5" class="tab active">
    <div class="padding">
      <div id="ui">
        <div class="ui-wrapper container">
          <div class="ui-main-text">
            <h1 data-aos="fade-in" data-aos-duration="2000">
              <WordAnimator />
              <!-- A Catalyst at the Intersection of
              <transition-group
                name="fade"
                tag="span"
                class="changing-text"
                mode="out-in"
              >
                <h1
                  v-if="currentPhrase === phrases[currentIndex]"
                  :key="currentPhrase"
                  class="animated-text"
                >
                  {{ currentPhrase }}
                </h1>
              </transition-group> -->
            </h1>
            <p data-aos="fade-up" data-aos-duration="1000">
              Hi, I'm <a href="/about">Ujjwal Verma</a>, UX Designer III at
              <a href="https://hashedin.com/" target="_blank">
                HashedIn by Deloitte</a
              >. Having a passion for crafting beautiful, user-friendly products
              where aesthetics meet purpose, and every pixel solves a problem.
            </p>
            <!-- Designed
              <a
                href="https://www.afaqs.com/labs/result/foxglove-2021.html"
                target="_blank"
                >Foxglove Awards by Shutterstock 2021</a
              >

              Winning website (Cobold.in) -->
          </div>
          <div>
            <div class="grid">
              <div v-for="(item, index) in list" :key="index">
                <div
                  class="ui-cards"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <!-- <div :class="'site-link ' + item.showlink">
                  <a :href="item.url" target="_blank">
                    <div>Project</div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      id="link-svg"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-external-link"
                    >
                      <path
                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                      ></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                  </a>
                </div> -->
                  <router-link
                    @click.native="handleClick"
                    :to="{ name: item.url }"
                  >
                    <img class="ui-img" :src="item.image" />
                    <img class="ui-shadow" :src="item.image" />

                    <div class="card-text">
                      <h4>{{ item.title }}</h4>
                      <p>{{ item.desc }}</p>
                    </div>
                  </router-link>
                  <a :href="item.url"> </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hire />
    </div>
  </div>
</template>

<script>
import Hire from "./Hire.vue";
import WordAnimator from "@/components/WordAnimator.vue";

export default {
  components: { Hire, WordAnimator },

  data() {
    return {
      phrases: ["Creativity", "User Experience", "Strategy", "Business Impact"],
      currentIndex: 0,
      currentPhrase: "Creativity",
      animationInterval: null,
      list: [
        {
          image: "/img/gallery/ui/petfood.jpg",
          title: "Pet Food",
          desc: "Mobile First Website | UI | Pet Food Brand",
          url: "PetFood",
        },
        {
          image: "/img/gallery/ui/Runway.jpg",
          title: "Runway",
          desc: "Web Design | Banner | Incubator Brand",
          url: "Runway",
        },
        {
          image: "/img/gallery/ui/Swastik.jpg",
          title: "Swastik App",
          desc: "Web Design | UI | Custom Shopping",
          url: "Swastik",
        },
        {
          image: "/img/gallery/ui/Cobold.jpg",
          title: "Cobold Digital",
          desc: "Web Design | UI | Digital Agency",
          url: "Cobold",
        },
        {
          image: "/img/gallery/ui/ecoplore.jpg",
          title: "Ecoplore",
          desc: "Web Design | UI | Travel",
          url: "Ecoplore",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/vj.jpg",
          title: "Vasundhra Jewellers",
          desc: "Web Design | UI | Jewellery",
          url: "Vasundhra",
          showlink: "showlink",
        },
        // {
        //   image: "/img/gallery/ui/Concept.jpg",
        //   title: "Concepts",
        //   desc: "Web Design | UI/UX | Website Template",
        // },
        {
          image: "/img/gallery/ui/dhanam.jpg",
          title: "Dhanam",
          desc: "App Design | UI/UX",
          url: "Dhanam",
        },
        {
          image: "/img/gallery/ui/bound.jpg",
          title: "Bound",
          desc: "Branding | Design",
          url: "Bound",
        },
        {
          image: "/img/gallery/ui/Healing-gardens.jpg",
          title: "Healing Gardens",
          desc: "Web Design | UI | Garden Event",
          url: "Healinggarden",
        },
        {
          image: "/img/gallery/ui/zsites-full.jpg",
          title: "Zsites",
          desc: "Web Design | UI/UX | Website Creators",
          url: "Zsites",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/Max.jpg",
          title: "Max Square",
          desc: "Web Design | UI/UX | Real Estate",
          url: "Max",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/zsites.jpg",
          title: "Zsites - Landing Page",
          desc: "Web Design | UI/UX | Landing Page",
          url: "ZsitesLanding",
          showlink: "showlink",
        },
        {
          image: "/img/gallery/ui/bsc.jpg",
          title: "Battle Station App",
          url: "Battlestations",
          desc: "App | UI | Gaming",
        },
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },

  created() {
    this.startAnimation();
  },

  beforeDestroy() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  },

  methods: {
    handleClick() {
      this.$nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    },
    startAnimation() {
      this.animationInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.phrases.length;
        this.currentPhrase = this.phrases[this.currentIndex];
      }, 3000);
    },
  },
};
</script>

<style scoped>
.changing-text {
  display: inline-block;
  min-width: 200px;
  position: relative;
}

.animated-text {
  display: inline-block;
  position: absolute;
  left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter {
  opacity: 0;
  transform: translateY(20px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
